import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { AccountIcon } from "components"
import COLOR_PALETTE from "constants/color-palette"
import TopNavigationItem from "./top-navigation-item"
import AnimatedDropdown from "./animated-dropdown"
import { PrimaryNavigationItem } from "./navigation-item"
import { dropdownWidth, breakpointTablet } from "../settings"

export const AccountButton = ({ name, ...props }) => (
  <TopNavigationItem label={name} Icon={AccountIcon} {...props} />
)

AccountButton.propTypes = {
  name: PropTypes.string
}

const AccountDropdown = ({ open, items }) => (
  <AnimatedDropdown open={open}>
    <div style={style.menu}>
      {items.map((item, index) => (
        <div key={index} style={{ borderBottom: "1px solid #545454" }}>
          <PrimaryNavigationItem {...item} />
        </div>
      ))}
    </div>
  </AnimatedDropdown>
)

const style = {
  menu: {
    background: COLOR_PALETTE.GRAY3,
    marginLeft: "auto",
    width: "100%",
    [breakpointTablet]: {
      width: dropdownWidth
    }
  }
}

AccountDropdown.propTypes = {
  open: PropTypes.bool,
  items: PropTypes.array
}

export default Radium(AccountDropdown)



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/account.jsx